import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import Icon from './Icon';

interface DialogInterface {
  children: React.ReactNode;
  isOpen: boolean;
  setFunction: (isOpen: boolean) => void;
}
const FullScreenDialog = ({
  setFunction,
  children,
  isOpen,
}: DialogInterface) => {
  const handleEscapeKeyPress = (event) => {
    if (event.key === 'Escape') {
      setFunction(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleEscapeKeyPress);
    return () => {
      window.removeEventListener('keydown', handleEscapeKeyPress);
    };
  }, []);

  return (
    <>
      <dialog
        open={isOpen}
        className={clsx(
          'fixed bottom-0 right-0 top-0 z-50 flex h-[100vh] w-[100vw] items-center justify-center  p-4 transition-all lg:p-8',
          isOpen ? 'left-0' : 'left-full'
        )}
      >
        <button
          className="absolute right-4 top-4"
          onClick={() => setFunction(false)}
        >
          <Icon name="close" className="h-5 w-5" />
        </button>
        <div className="bg-gray-50">{children}</div>
      </dialog>
    </>
  );
};

export default FullScreenDialog;
